var render = function render(){var _vm=this,_c=_vm._self._c;return _c('centered-layout',[(_vm.loading)?_c('v-progress-circular',{attrs:{"indeterminate":true,"color":"primary"}}):_vm._e(),_c('GlobalErrorInline',{attrs:{"errors":_vm.errors}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }